<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="emailAddressAudits && emailAddressAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list (nextPage)="onNextPage()" [audits]="emailAddressAudits">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Email Address audits </ng-template>
</ng-template>
